export const cartPreviewAddProducts = products => ({
  type: "CARTPREVIEW_ADD_PRODUCTS",
  payload: products
});

export const cartPreviewDeleteProducts = () => ({
  type: "CARTPREVIEW_DELETE_PRODUCTS",
  payload: []
});
